import { useEffect } from 'react';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useIlsListSize from 'automation-ui-enrollment/hooks/useILSListSize';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ILSListSizeLoader = ({
  listId,
  setListSize,
  pollingStatus
}) => {
  const {
    loading: listSizeLoading,
    listSize
  } = useIlsListSize({
    listId
  });
  useEffect(() => {
    setListSize(listSize);
  }, [listSize, setListSize]);
  if (listSizeLoading || pollingStatus !== 'COMPLETE') {
    const label = listSizeLoading ? /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.events.enrollExisting.previewProcessing"
      })
    }) : /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.events.enrollExisting.previewLoading"
      })
    });
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      minHeight: 150,
      layout: "centered",
      label: label,
      showLabel: pollingStatus === 'POLLING' || listSizeLoading
    });
  } else {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
};
export default ILSListSizeLoader;